var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / NP") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.99079514 C0,0.891309342 0.902811686,8.75359558e-10 1.99375407,1.93298888e-09 L1.99375407,1.93298888e-09 C2.36539343,2.29327985e-09 2.91798846,0.167547864 3.21742288,0.367170813 L17.5542808,9.92507611 C18.1686346,10.3346453 18.0626183,10.6666667 17.3372931,10.6666667 L8,10.6666667 L17.6631726,19.1219427 C18.2173871,19.6068803 18.066735,20 17.324206,20 L1.99766032,20 C0.89438299,20 0,19.1017876 0,18.0092049 L0,1.99079514 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-NP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99375407,0.666666667 C2.25291216,0.666666667 2.63867923,0.782575323 2.84762275,0.921871007 L2.84762275,0.921871007 L15.5793588,9.40969505 L6.36816409,10.1246557 L15.9833666,18.5379579 L0.666666667,19.2993693 L0.666666667,0.666666667 Z",
    id: "Mask-Copy",
    stroke: "#0543A8",
    strokeWidth: 1.33333333,
    fill: "#EE1B44",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35382249,12.2029879 L6.27614237,13.7238576 L7.79701209,13.6461775 L6.66666667,14.6666667 L7.79701209,15.6871558 L6.27614237,15.6094757 L6.35382249,17.1303454 L5.33333333,16 L4.31284418,17.1303454 L4.39052429,15.6094757 L2.86965458,15.6871558 L4,14.6666667 L2.86965458,13.6461775 L4.39052429,13.7238576 L4.31284418,12.2029879 L5.33333333,13.3333333 L6.35382249,12.2029879 Z M6.0987002,5.48557427 L6.04044011,6.62622655 L7.1810924,6.56796647 L6.33333333,7.33333333 L6.8512523,7.80072208 C7.23524362,7.69547528 7.58925517,7.55154826 7.90237433,7.37621609 C7.59159419,8.50472154 6.55819051,9.33333333 5.33125417,9.33333333 C4.10431783,9.33333333 3.07091415,8.50472154 2.76011916,7.37657399 C3.07534755,7.55255424 3.43013889,7.696565 3.81497663,7.80174037 L4.33333333,7.33333333 L3.48557427,6.56796647 L4.62622655,6.62622655 L4.56796647,5.48557427 L5.33333333,6.33333333 L6.0987002,5.48557427 Z",
    id: "Star-93",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNp);
export default __webpack_public_path__ + "static/media/NP.c386e5b05aa0979b5d841cf45d2a3bd4.svg";
export { ForwardRef as ReactComponent };